import { useSuspenseQuery } from "@tanstack/react-query";
import { listAppInstallations } from "../openapi/api-client.ts";
import { ListUsersError } from "../errors/ListUsersError.ts";

export const useListAppInstallations = (projectId: string) =>
  useSuspenseQuery({
    queryKey: ["appInstallations", { projectId }],
    queryFn: async () => {
      const response = await listAppInstallations({
        path: { projectId },
      });

      if (!response.data) {
        throw new ListUsersError(
          `error while fetching app installations: ${response.error.message}`,
        );
      }

      return response.data;
    },
  });
